import { IonContent, IonPage } from '@ionic/react';
import { useHistory } from 'react-router-dom';

import '../pm/theme.css';

interface HubCard {
  title: string;
  description: string;
  path: string;
}

const CARDS: HubCard[] = [
  {
    title: 'Forwarding numbers',
    description: 'Manage receiving numbers and their owners.',
    path: '/Operator/Receiving-Numbers',
  },
  {
    title: 'Client teams',
    description: 'Provision teams for each client engagement and manage their members.',
    path: '/Operator/Teams',
  },
  {
    title: 'Internal team',
    description: 'Manage Rollover Rep operators, their roles, and platform access.',
    path: '/Operator/Internal',
  },
  {
    title: 'Intake logs',
    description: 'Per-client dashboard and search over the intake-form lambda logs.',
    path: '/Operator/Logs',
  },
  {
    title: 'Permissions',
    description: 'Grant per-user access to each microservice (super admin only).',
    path: '/Operator/Permissions',
  },
  {
    title: 'Exec dashboard',
    description: 'Portfolio call-volume and telephony KPIs per client.',
    path: '/Operator/Exec',
  },
  {
    title: 'Billing audit',
    description: 'Monthly calls-vs-intake-forms reconciliation and final billing numbers.',
    path: '/Operator/Billing-Audit',
  },
];

const OperatorHub: React.FC = () => {
  const history = useHistory();

  return (
    <IonPage>
      <IonContent fullscreen>
        <div className="pm-app">
          <div className="pm-page">
            <div className="pm-header">
              <div className="pm-header-titles">
                <h1>Operator</h1>
                <p>Rollover Rep platform management.</p>
              </div>
            </div>

            <div className="pm-hub-grid">
              {CARDS.map((c) => (
                <button
                  key={c.path}
                  className="pm-hub-card"
                  onClick={() => history.push(c.path)}
                >
                  <h3>{c.title}</h3>
                  <p>{c.description}</p>
                  <span className="pm-hub-card-cta">Open →</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default OperatorHub;
